//window.Vue = require('vue');

window.Vue = require('vue');
window.axios = require('axios');

//import Vue from "vue"
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es';
import Timetable from './components/Calendar/Timetable.vue';
import TimetableOptions from './components/Calendar/TimetableOptions.vue'

Vue.use(Element, { size: 'large', locale});

const app = new Vue({
    el: '#timetable-vue',
    components: { 'timetable': Timetable, 'timetableoptions': TimetableOptions },
});